import React from "react";

function ToggleBtn({ active, onClick, activeText, inActiveText }) {
  return (
    <button
      className={`btn btn-xs me-2 ${active ? "btn-danger" : "btn-primary"}`}
      onClick={onClick}
    >
      {active ? activeText : inActiveText}
    </button>
  );
}

export default ToggleBtn;
